import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { tryParseJSON } from '../utils';
import { LOCAL_ORG_USER, TRAINING_PRODUCT_TYPES, USER_ROLES } from '../constants';

export const useActiveProduct = (id) => {
     const location = useLocation();
     const products = useSelector((state) => state.subscriber.products.list);

     if (id) {
          return products?.find((prod) => prod.id === id);
     }

     const pathNameSplit = location.pathname.split('/');
     const product = products?.find((prod) => pathNameSplit.includes(prod.slug));

     if (product?.relatedAlternateProductId) {
          const alternateProduct = products?.find((prod) => prod.id === product.relatedAlternateProductId);
          if (alternateProduct) {
               product.alternateProduct = alternateProduct;
          }
     }

     const isPurchaseDigital = product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PURCHASE_DIGITAL_DOWNLOAD;
     if (isPurchaseDigital) {
          const alternateParentProduct = products?.find((prod) => prod.relatedAlternateProductId === product.id);
          if (alternateParentProduct) {
               product.alternateParentProduct = alternateParentProduct;
          }
     }

     return product;
};

export const useIsSupperAdmin = () => {
     const user = useSelector((state) => state.subscriber.user);
     const userRole = user?.role;

     return userRole === USER_ROLES.SYSTEM_ADMIN;
};

export const useCountry = () => {
     const user = useSelector((state) => state.subscriber.user);
     const currentCountry = useSelector((state) => state.subscriber.currentCountry);

     const localOrgUser = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));

     return currentCountry || localOrgUser.organization?.country || user?.country || '';
};
